export default {
  default: () => import("/app/dev/layouts/default.vue").then(m => m.default || m)
}